// extracted by mini-css-extract-plugin
module.exports = {"header":"SubscriptionNavigation_header__14x8P","logo":"SubscriptionNavigation_logo__Aou_O","active":"SubscriptionNavigation_active__2UTse"};